import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="mb-12 md:mb-16">
        <p className="text-foreground-500 text-xs md:text-sm font-medium tracking-widest uppercase mb-3">
          Browse by Category
        </p>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight max-w-2xl">
          Explore All <span className="italic text-primary-500">14 Categories</span>
        </h2>
        <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg">
          Click any category to jump directly to our verified spreadsheet listings on kaspreadsheet.com.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {categories.map((cat) => (
          <a
            key={cat.name}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
          >
            <div className="relative w-full aspect-[4/5] overflow-hidden">
              <img
                src={cat.image}
                alt={`${cat.name} spreadsheet deals on GTBuy Sheet`}
                title={`${cat.name} - GTBuy Sheet Spreadsheet Shopping`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="px-4 py-3.5">
              <p className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}